/*
 * @Author: Teemo Ding
 * @Date: 2021-07-19 09:11:18
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-02 17:01:43
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Payment/PaymentEditPage/AvailableMethods/index.tsx
 */

import { SizeFittingTable } from '@/src/components/Antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { methodsColumns } from '../config';
import css from '../css.module.less';

const AvailableMethods = ({ methods = [], processingFeeChange, disabled }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <SectionWrapper
      titleClassName={css.titleContainerAll}
      rightPart={''}
      title={getI18n('storePayment.paymentEditPage.availableMethods')}>
      {disabled ? null : (
        <SizeFittingTable
          id={'Store Setting Available Methods'}
          rowKey={(record) => record?.paymentMethod?.uuid}
          bordered
          rowClassName={css.row}
          className={css.table}
          pagination={false}
          columns={methodsColumns(processingFeeChange, { getI18n })}
          dataSource={methods}
        />
      )}
    </SectionWrapper>
  );
};

export default AvailableMethods;
